import React, { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { devActions } from '../../../redux/actions';

export const Navigator = () => {
  
  const iframeRef = useRef();
  const dispatch = useDispatch();
  const url = useSelector(state => state.dev.navigator.url);

  const [inputUrl, setInputUrl] = useState(url);
  const [iframeUrl, setIframeUrl] = useState(url);

  const handleUrlChange = (event) => {
    setInputUrl(event.target.value);
  };
  
  const handleGo = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(devActions.changeNavigatorUrl(inputUrl))
    setIframeUrl(inputUrl);
  };

  const handleMessage = useCallback((event) => {
    console.debug("llego un mensaje", event)
    if (event.data && event.data.type === 'console') {
      console.log('Mensaje de consola del iframe:', event.data);
    }
  }, []);


  const handleOnLoad = (event) => {
    console.log(event);
    if(iframeRef?.current?.contentWindow){
      console.debug("registrando eventlistener")
      try{
        iframeRef.current.contentWindow.addEventListener('message', handleMessage);
      }catch(e){
      }
    } 
  }

  return (
    <>
      <form onSubmit={handleGo}>
        <div style={{display: "flex", flexDirection: "row"}}>
          <input
            type="text"
            value={inputUrl}
            onChange={handleUrlChange}
            placeholder="Ingresá la URL"
            style={{
              flex: 1,
              backgroundColor: "#cdcdcd",
              border: "1px solid #a3a3a3",
              outline: "none",
              minWidth: 50
            }}
          />
          <input type="submit" value="Ir" className='btn btn-primary' style={{borderRadius: 0}} />
        </div>
      </form>
      {iframeUrl && (
        <iframe
          onLoad={handleOnLoad}
          ref={iframeRef}
          src={iframeUrl}
          title="URL Iframe"
          width="100%"
          height="100%"
          frameBorder="0"
        />
      )}
    </>
  );
}